import { Injectable } from '@angular/core';
import { Auth, user, signInWithEmailAndPassword, signOut, User, sendPasswordResetEmail } from '@angular/fire/auth';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})
export class AuthService {
	readonly user$: Observable<User | null>;

  	constructor(private auth: Auth) {
		this.user$ = user(this.auth).pipe(shareReplay(1));
	}

	get authInstance(): Auth {
		return this.auth;
	}

	async login(email: string, password: string): Promise<any> {
    	return signInWithEmailAndPassword(this.auth, email, password);
  	}

	async logout(): Promise<void> {
  		return signOut(this.auth);
	}

	async resetPassword(email: string): Promise<any> {
		return sendPasswordResetEmail(this.auth, email);
	}
}